import { render, staticRenderFns } from "./ProjectCardSlider.vue?vue&type=template&id=625b8d5f&scoped=true&"
import script from "./ProjectCardSlider.vue?vue&type=script&lang=js&"
export * from "./ProjectCardSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCardSlider.vue?vue&type=style&index=0&id=625b8d5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625b8d5f",
  null
  
)

export default component.exports